// extracted by mini-css-extract-plugin
module.exports = {"condition":"ParamCondition_condition__20rVT"};